import * as React from 'react';
import { useTheme } from '../../../theme';
import { arrowIcon, emptyCard } from '../../Icons';
import { ButtonBase } from '@mui/material';
import { PaymentType } from '../../../PaymentForm/types';
import { buildDataAttributes } from '@shared/lib/dom';

export interface GatewayProps {
	header: React.ReactNode;
	type?: string;
	onClick?: (e: React.MouseEvent) => void;
	description?: string | React.ReactNode;
	paymentType: PaymentType | 'Test';
}

const Gateway: React.FC<GatewayProps> = ({ type, header, description, onClick, paymentType }) => {
	const { Gateway: css } = useTheme('PaymentForm');

	return (
		<ButtonBase
			className={css.selector}
			onClick={onClick}
			{...buildDataAttributes({
				'payment-type': paymentType,
				'test-id': 'payment-method'
			})}
		>
			<div className={css.header}>
				{header ?? emptyCard}
				<span className={css.header__arrow}>
					<span>{type}</span> <span className={css.arrow}>{arrowIcon}</span>
				</span>
			</div>

			{description && <p className={css.description}>{description}</p>}
		</ButtonBase>
	);
};

export default Gateway;
